import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { logPageView } from "../../util/analytics";
import useEvent from "../../hooks/useEvent";

/**
 * Component that logs page views on route changes
 * Should be placed inside Router but outside routes
 */
const PageViewTracker = () => {
  const location = useLocation();
  const eventContext = useEvent();

  useEffect(function logPageViewOnRouteChange() {
    // Log page view whenever location changes
    logPageView(eventContext);
  }, [location.pathname, location.search]);

  return null; // This component doesn't render anything
};

export default PageViewTracker;

